import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import './typography.scss';

function renderElement({ type, content }, key) {
  if (type === 'h1') {
    return (
      <h1 key={key} dangerouslySetInnerHTML={{ __html: content }}/>
    );
  }

  if (type === 'h2') {
    return (
      <h2 key={key} dangerouslySetInnerHTML={{ __html: content }}/>
    );
  }

  if (type === 'p') {
    return (
      <p key={key} dangerouslySetInnerHTML={{ __html: content }}/>
    );
  }

  if (type === 'ul') {
    return (
      <ul key={key} className="typography-ul">
        {content.map((el, i) =>
          <li key={i} dangerouslySetInnerHTML={{ __html: el }} />
        )}
      </ul>
    );
  }

  if (type === 'group') {
    return (
      <ul key={key} className="typography-group">
        {content.map((el, i) =>
          <li key={i} dangerouslySetInnerHTML={{ __html: el }} />
        )}
      </ul>
    );
  }

  if (type === 'column') {
    return (
      <div key={key} className="typography-column">
        {content.map(renderElement)}
      </div>
    );
  }

  return null;
}

class Typography extends PureComponent {
  render() {
    return (
      <div className="typography">
        {this.props.content.map(renderElement)}
      </div>
    );
  }
}


Typography.propTypes = {
  content: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      content: PropTypes.any
    })
  )
};

export default Typography;



// WEBPACK FOOTER //
// ./src/components/widgets/Typography/Typography.js